<nb-card class="searcher" *ngIf="form">
  <nb-card-header>
    <h1>{{ 'searchfor' | translate:{value: definition.title} }}</h1>
  </nb-card-header>
  <nb-card-body>
    <article class="search-params">
      <div class="side-params">
        <h2>{{ 'filters' | translate }}</h2>
        <div class="inputs" (scroll)="this.scroll.fireScrollChange($event)" [class.nb-global-scrollblock]="!this.scrolling">
          <div *ngFor="let d of sideDefs" [ngStyle]="d.style">
            <ng-container *ngTemplateOutlet="searchParam; context: {d: d}"></ng-container>
          </div>
        </div>
        <div class="buttons">
          <button nbButton type="button" (click)="reset()" status="basic">{{'reset' | translate }}</button>
          <button nbButton type="button" (click)="search()" status="primary">{{ 'search' | translate }}</button>
        </div>
      </div>
    </article>
    <article class="search-results">
      <h2>{{ 'shell.search_results' | translate }}</h2>
      <div class="top-params">
        <div *ngFor="let d of topDefs" [ngStyle]="d.style">
          <ng-container *ngTemplateOutlet="searchParam; context: {d: d}"></ng-container>
        </div>
      </div>
      <table *ngIf="headerTemplate && bodyTemplate && results.length;"
             (scroll)="scroll.fireScrollChange($event)"
             [nbSpinner]="isLoading" nbSpinnerStatus="primary" nbSpinnerSize="large" class="standard"
             infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="100"
             [class.nb-global-scrollblock]="!this.scrolling" [scrollWindow]="false" (scrolled)="scrolled()">
        <thead>
          <ng-container *ngTemplateOutlet="headerTemplate">
          </ng-container>
        </thead>
        <tbody>
          <ng-container *ngFor="let r of results; let i = index" [ngTemplateOutlet]="bodyTemplate" [ngTemplateOutletContext]="{data: r, select: selected, isSelected:isSelected(r), params: params, i:i}">
          </ng-container>
        </tbody>
        <tfoot [nbSpinner]="this.appending" [class.appending]="this.appending">

        </tfoot>
      </table>
      <div *ngIf="!results.length" class="noresults" role="status" [attr.aria-busy]="isLoading" [nbSpinner]="isLoading" nbSpinnerStatus="primary" nbSpinnerSize="large">
        {{ (isLoading ? 'loading' : 'noresults') | translate }}
      </div>
    </article>
    <article class="search-selections">
      <h2>{{ 'shell.selected_items' | translate }}</h2>
      <table *ngIf="headerTemplate && bodyTemplate && selections.length" class="standard">
        <thead>
        <ng-container *ngTemplateOutlet="selectionHeaderTemplate || headerTemplate">
        </ng-container>
        </thead>
        <tbody>
        <ng-container *ngFor="let r of selections" [ngTemplateOutlet]="selectionBodyTemplate || bodyTemplate" [ngTemplateOutletContext]="{data: r, select: selected, isSelected:isSelected(r), params: params}">
        </ng-container>
        </tbody>
      </table>
      <ng-container *ngIf="summaryTemplate" [ngTemplateOutlet]="summaryTemplate" [ngTemplateOutletContext]="{data: selections, params: params}"></ng-container>
      <div *ngIf="!selections.length" class="noresults">
        {{ 'nothingselected' | translate }}
      </div>
      <div *ngIf="!buttonTemplate" class="buttons">
        <button nbButton status="basic" type="button" (click)="cancel()">{{ 'cancel' | translate }}</button>
        <button nbButton status="primary" type="button" [disabled]="!selections.length" (click)="finish()">{{ 'insert' | translate }}</button>
      </div>
      <ng-container *ngIf="buttonTemplate" [ngTemplateOutlet]="buttonTemplate" [ngTemplateOutletContext]="{search: this, data: selections, params: params}"></ng-container>
    </article>
  </nb-card-body>
</nb-card>

<ng-template #searchParam let-d="d">
  <ng-container [ngSwitch]="d.type" [formGroup]="form">
    <label>{{ d.title }}</label>
    <div>
      <ng-container *ngSwitchCase="ColType.RANGE">
        <input nbInput class="input-full-width" [placeholder]="'enterdaterange' | translate" [nbDatepicker]="rangepicker" [formControlName]="d.name">
        <nb-rangepicker #rangepicker></nb-rangepicker>
      </ng-container>
      <nb-select *ngSwitchCase="ColType.SELECT" [formControlName]="d.name" [scrollStrategy]="this.scrollStrategy" [placeholder]="'select' | translate:{value: d.title}">
        <nb-option *ngFor="let l of d.list" [value]="l.id">
          {{ l.name }}
        </nb-option>
      </nb-select>
      <nb-select *ngSwitchCase="ColType.BOOL" [formControlName]="d.name" [scrollStrategy]="this.scrollStrategy" [placeholder]="'?' | translate">
        <nb-option [value]="null">{{ '?' | translate }}</nb-option>
        <nb-option [value]="true">{{ 'yes' | translate }}</nb-option>
        <nb-option [value]="false">{{ 'nee' | translate }}</nb-option>
      </nb-select>
      <textarea *ngSwitchCase="ColType.AREA" nbInput [formControlName]="d.name" [maxLength]="d.length" [placeholder]="'searchplaceholder' | translate:{value: d.subtitle || d.title}"></textarea>
      <input *ngSwitchCase="ColType.INT" nbInput type="number" [formControlName]="d.name" min="0" max="1000000" [step]="d.length || 10" [placeholder]="'enternumber' | translate:{value: d.title}">
      <nb-radio-group *ngSwitchCase="ColType.RADIO" [name]="d.name" [formControlName]="d.name">
        <nb-radio [value]="null">{{ 'any' | translate }}</nb-radio>
        <nb-radio *ngFor="let l of d.list" [value]="l.id">{{ l.name }}</nb-radio>
      </nb-radio-group>
      <bst-list-adder *ngSwitchCase="ColType.SEARCH" [target]="d.name" [formControlName]="d.name" [autolist]="true"></bst-list-adder>
      <input *ngSwitchDefault nbInput type="text" [formControlName]="d.name" [placeholder]="'searchplaceholder' | translate:{value: d.title}">
    </div>
  </ng-container>
</ng-template>
